import { every, isEmpty } from 'lodash';

//  enable delay before displaying Highcharts Tooltip.
//  tooltip: { delayForDisplay: milliseconds }
export function enableHighchartsDelayedTooltip(Highcharts) {
  const timerId = {};

  const generatePointsUniqueKey = points => {
    const generatePointKey = point => {
      return `${point.category} ${point.series.name}: ${point.x} ${point.y}`;
    };

    const result = points.map(generatePointKey).join(', ');

    return result;
  };

  function inArray(value, arr) {
    return value === arr || (Array.isArray(arr) && arr.some(element => element === value));
  }

  Highcharts.wrap(Highcharts.Tooltip.prototype, 'refresh', function onRefresh(proceed, ...args) {
    const { delayForDisplay } = this.chart.options.tooltip;
    if (delayForDisplay > 0) {
      const seriesName = Array.isArray(args[0])
        ? generatePointsUniqueKey(args[0])
        : args[0].series.name;

      if (timerId[seriesName]) {
        clearTimeout(timerId[seriesName]);
        delete timerId[seriesName];
      }

      this.chart.tooltip.hide();
      timerId[seriesName] = setTimeout(() => {
        if (inArray(this.chart.hoverPoint, args[0])) {
          if (!every(args[0], isEmpty)) proceed.apply(this, args);
        }
      }, delayForDisplay);
    } else {
      proceed.apply(this, args);
    }
  });
}
